import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import GlobalTheme from '../../../../styled/GlobalTheme';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: ${({ hasImage }) => (hasImage ? 'row' : 'column')};
  align-items: flex-end;
  ${GlobalTheme.breakpoints.down('sm')}{
    align-items: center;
    padding: 30px 0 0 0;
  }
  @media (max-height: 425px) {
    align-items: center;
    padding: 30px 0 0 0;
  }
`;

const Title = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: 30px;
  line-height: 100%;
  text-align: center;
  padding: 30px;
  color: ${({ theme }) => (theme.colors.white)};
  ${GlobalTheme.breakpoints.down('md')}{
    padding-bottom: 10px;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    font-size: 28px;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  @media (max-height: 425px) {
    padding: 0 0 8px 0;
    font-size: 25px;
  }
`;

const Text = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;
  padding: ${({ hasImage }) => (hasImage ? '0' : '0 185px')};
  color: ${({ theme }) => (theme.colors.white)};
  text-align: ${({ hasImage }) => (hasImage ? 'left' : 'center')};
  width: ${({ hasImage }) => (hasImage ? '530px' : '100%')};
  ${GlobalTheme.breakpoints.down('md')}{
    padding: ${({ hasImage }) => (hasImage ? '0' : '0 94px')};
    width: ${({ hasImage }) => (hasImage ? '445px' : '100%')};
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    font-size: 18px;
    padding: ${({ hasImage }) => (hasImage ? '0' : '0 15px')};
    width: ${({ hasImage }) => (hasImage ? '280px' : '100%')};
    text-align: center;
    line-height: 22px;
    padding-top: 15px;
  }
  @media (max-height: 425px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

const Image = styled.img`
  width: 100%; 
  height: 100%; 
  object-fit: contain;
`;

const ImageBox = styled.div`
  height: 80px;
  width: 164px;
  margin-right: 20px;
  ${GlobalTheme.breakpoints.down('sm')}{
    height: 60px;
    width: 123px;
    margin-right: 0px;
  }
  @media (max-height: 425px) {
    width: 100px;
    height: 50px;
  }
`;

const HeaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${GlobalTheme.breakpoints.down('sm')}{
    flex-direction: column;
    align-items: center;
  }
  @media (max-height: 425px) {
    height: fit-content;
    align-items: center;
  }
`;

const HeaderSlider = ({
  image,
  title,
  text,
  hasImage,
}) => (
  <Container
    hasImage={hasImage}
  >
    {!hasImage && (
      <Title>
        {title}
      </Title>
    )}
    <HeaderBox>
      {hasImage && (
        <ImageBox>
          <Image
            src={image}
          />
        </ImageBox>
      )}
      <Text
        hasImage={hasImage}
      >
        {text}
      </Text>
    </HeaderBox>
  </Container>
);

HeaderSlider.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  hasImage: PropTypes.bool.isRequired,
};

HeaderSlider.defaultProps = {
  image: '',
  title: '',
};

export default HeaderSlider;
